/* DATALAYER - Button add cart */
/* -------------------------------------------------------------------------------------- */
function productClickDataLayer(elemento) {
	/* Act on the event */
	var dataLayerTitle = elemento.attr('data-title');
	var dataLayerID = elemento.attr('data-id');
	var dataLayerPrice = elemento.attr('data-price');
	var dataLayerVendor = elemento.attr('data-vendor');
	var dataLayerType = elemento.attr('data-type');
	var dataLayerVariant = elemento.attr('data-product-variant-id');
	var dataLayerCollection = elemento.attr('data-collection');

	window.dataLayer.push({ 'event': 'eec.productClick',
		'ecommerce': {
			'click': {
					'actionField': {'list': `${dataLayerCollection}`}
			},
			'products': [{
					'name': `${dataLayerTitle}`,
					'id': `${dataLayerID}`,
					'price': `${dataLayerPrice}`,
					'brand': `${dataLayerVendor}`,
					'category': `${dataLayerType}`,
					'variant': `${dataLayerVariant}`
			}]
		}
	});
}

function addToCartDataLayer(elemento){
	var dataLayerSize = elemento.attr('data-size');
	var dataLayerTitle = elemento.attr('data-title');
	var dataLayerID = elemento.attr('data-id');
	var dataLayerPrice = elemento.attr('data-price');
	var dataLayerVendor = elemento.attr('data-vendor');
	var dataLayerType = elemento.attr('data-type');
	var dataLayerVariant = elemento.attr('data-product-variant-id');
	var dataLayerCollection = elemento.attr('data-collection');

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': 'add_to_cart', 
		'ecommerce': {
			'items': [{
			'item_name': `${dataLayerTitle}`,
			'item_id': `${dataLayerID}`,
						'price': `${dataLayerPrice}`,
						'item_brand': `${dataLayerVendor}`,
						'item_category': `${dataLayerType}`,
						'item_category2': '',
						'item_category3': '',
						'item_category4': '',
						'item_variant': `${dataLayerSize}`,
						'item_variant2': '',
						'item_list_name': `${dataLayerCollection}`,
						'item_list_id': '',
						'quantity': '1',
						'index': '',  
			}],
		}
	});
}

window.addEventListener('load', ()=>{
	/* Add to cart - Minicart */
	/* -------------------------------------------------------------------------------------- */
	$("[js-product-template]").on('click', '.js-add-product-minicart', function(event) {
		event.preventDefault();
		event.stopPropagation();
		var el = $(this),
			product_id = parseFloat(el.attr("data-product-variant-id")),
			product_quantity = parseFloat(el.attr("data-product-quantity"));
			el.find('[data-add-to-cart-text]').addClass('d-none');
			el.find('[data-loader]').removeClass('d-none');
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: {
				quantity: product_quantity,
				id: product_id
			},
			dataType: 'json',
			async: false,
			success: function(){
				addMiniCart();
				$('[js-product-template] .js-product-message').addClass('d-none');
			},
			complete: function(){
				el.find('[data-loader]').addClass('d-none');
				el.find('[data-add-to-cart-text]').removeClass('d-none');
			},
			error: function(response) {
				$('[js-product-template] [js-product-template-message]').removeClass('d-none');
				$('[js-product-template] [text-message-warning]').empty().append(response.responseJSON.description);
				el.find('[data-loader]').addClass('d-none');
				el.find('[data-add-to-cart-text]').removeClass('d-none');
			}
		});
		$('.js-add-product-template').trigger('click');
	});
	/* Add to cart - Notificaiton */
	/* -------------------------------------------------------------------------------------- */
	$('body').on('click', '.js-add-product-notification', function(event) {
		event.preventDefault();
		event.stopPropagation();
		var el = $(this);
		var product_id = parseFloat(el.attr("data-product-variant-id"));
		var product_quantity = parseFloat(el.attr("data-product-quantity"));
		var flagParent = (el.attr("data-product-flag-parent") == undefined) ? true : JSON.parse(el.attr("data-product-flag-parent"));
		var productParent = parseFloat(el.attr("data-product-id-parent"));
		// Product loading message on CARD
		el.find('[data-add-to-cart-text]').addClass('d-none');
		el.find('[data-loader]').removeClass('d-none');
		// ADD Product to cart
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: {
				quantity: product_quantity,
				id: product_id
			},
			dataType: 'json',
			success: function(){
				// Turn on notification
				addMiniCartNotification(product_id, flagParent, productParent);
				// Error message
				$('[js-product-template] .js-product-message').addClass('d-none');
                $('[js-product-template] [js-product-template-message]').addClass('d-none');
			},
			complete: function(){
				el.find('[data-loader]').addClass('d-none');
				el.find('[data-add-to-cart-text]').removeClass('d-none');
			},
			error: function(response) {
				// Error message
				$('[js-product-template] [js-product-template-message]').removeClass('d-none');
				$('[js-product-template] [text-message-warning]').empty().append(response.responseJSON.description);
				el.find('[data-loader]').addClass('d-none');
				el.find('[data-add-to-cart-text]').removeClass('d-none');
			}
		});
		$('.js-add-product-template').trigger('click');
	});

	$('[js-product-template]').on('click', '.js-add-product-template', function(event) {
		event.preventDefault();
		/* Act on the event */
		var button = $(this);
		productClickDataLayer(button);
		addToCartDataLayer(button);
	});
	/* Product - Select variant */
	/* -------------------------------------------------------------------------------------- */
	$('[js-product-form-variants]').on('click', '.js-get-variant', function(event) {
		var el = $(this),
			idProduct = el.attr('data-product-id'),
			listVariants = $('.js-get-variant');
		if (el.hasClass('disabled')) {
			$('[js-product-template] [js-product-available-messagge]').addClass('active');
		}else {
			el.closest('[js-product-form-variants]').find('.js-get-variant').removeClass('active').removeAttr('checked');
			el.addClass('active').attr('checked', 'checked');
			var option = [];
			for (var i = 0; i < listVariants.length; i++) {
				if ($(listVariants[i]).hasClass('active')) {
					var position = $(listVariants[i]).attr('data-position');
					var listVariantslength = listVariants.length + 1;
						for (var j = 1; j < listVariantslength; ++j) {
						if (position == j) {
							option[j] = $(listVariants[i]).val();
						}
					}
				}
			}
			$.getJSON(idProduct+'.js', function(product) {
				var iProductVariants = product.variants;
				var currentVariant = _.find(iProductVariants, function (o) {
					return o.option1 == option[1] && o.option2 == option[2] && o.option3 == option[3];
				});

				if (currentVariant === undefined) {
					$('[js-product-template] [data-product-invalid]').removeClass('d-none');
				}else {
					var qVariantId = currentVariant.id;
					var qVariantAvailable = currentVariant.available;
					var qVariantSku = currentVariant.sku;
					var qVariantTitle = currentVariant.title;
					var qVariantPrice = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(currentVariant.price/100);
					var qVariantComparePrice = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(currentVariant.compare_at_price/100);
					$('[js-product-template] [data-product-invalid]').addClass('d-none');
					if (qVariantAvailable == false) {
						$('[js-product-template] [js-product-available-messagge]').addClass('active');
					}else {
						$('[js-product-template-buttons] .js-add-product-template').attr('data-product-variant-id', qVariantId);
						$('[js-product-template-buttons] .js-add-product-template').attr('data-size', qVariantTitle);
						$('[js-product-template-buttons] .js-add-product-minicart').attr('data-product-variant-id', qVariantId);
						$('[js-product-template-buttons] .js-add-product-notification').attr('data-product-variant-id', qVariantId);
						$('[js-product-template] [js-product-available-messagge]').removeClass('active');
						var selectVariant = $('.s-main-product__details .js-get-variant').hasClass('active');
						var selectMessage = $('.s-main-product__details a[js-size-message-button]').hasClass('d-none');
						if (selectVariant == true && selectMessage == false) {
							$('a[js-size-message-button]').addClass('d-none');
						}
						var newURL = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?variant=").concat(currentVariant.id);
						window.history.replaceState({
							path: newURL
						}, '', newURL);
					}
					if (currentVariant.compare_at_price >= currentVariant.price) {
						$('[js-product-template] [js-product-price-content]').addClass('price--on-sale');
					}else {
						$('[js-product-template] [js-product-price-content]').removeClass('price--on-sale');
					}
					$('[js-product-template] [data-product-price]').text(qVariantPrice);
					$('[js-product-template] [data-product-price-compare]').text(qVariantComparePrice);
					$('[js-product-template] [data-product-sku]').text(qVariantSku);
				}
			});
		}
	});
	/* Product - Input Quantity */
	/* -------------------------------------------------------------------------------------- */
	$('[js-product-template-quantity]').on('click', '[name=minus]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var spinner = $(this),
			input = spinner.closest('.js-quantity').find('input[type="number"]'),
			min = input.attr('min'),
			max = input.attr('max'),
			oldValue = parseFloat(input.val());
		if (oldValue <= min) {
			var newVal = oldValue;
		} else {
			var newVal = oldValue - 1;
		}
		input.val(newVal);
		input.trigger("change");
		$('[js-product-template-buttons] .js-add-product-template').attr('data-product-quantity', newVal);
		$('[js-product-template-buttons] .js-add-product-minicart').attr('data-product-quantity', newVal);
		$('[js-product-template-buttons] .js-add-product-notification').attr('data-product-quantity', newVal);
	});

	$('[js-product-template-quantity]').on('click', '[name=plus]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var spinner = $(this),
			input = spinner.closest('.js-quantity').find('input[type="number"]'),
			min = input.attr('min'),
			max = input.attr('max'),
			oldValue = parseFloat(input.val());
		if (oldValue >= max) {
			var newVal = oldValue;
		} else {
			var newVal = oldValue + 1;
		}
		input.val(newVal);
		input.trigger("change");
		$('[js-product-template-buttons] .js-add-product-template').attr('data-product-quantity', newVal);
		$('[js-product-template-buttons] .js-add-product-minicart').attr('data-product-quantity', newVal);
		$('[js-product-template-buttons] .js-add-product-notification').attr('data-product-quantity', newVal);
	});

	$('[js-product-template-quantity]').on('keyup', '.js-quantity input[type="number"]', debounce(function(){
		var input = $(this),
			inputValue = parseFloat(input.val());
		$('[js-product-template-buttons] .js-add-product-template').attr('data-product-quantity', inputValue);
		$('[js-product-template-buttons] .js-add-product-minicart').attr('data-product-quantity', inputValue);
		$('[js-product-template-buttons] .js-add-product-notification').attr('data-product-quantity', inputValue);
	},500));
});